import { ParentOptionData } from '../components/config/interfaces';

export const getJqlTextForMatchingOptionToDelete = (
    levelParents: ParentOptionData[],
    optionValue: string,
    levelToCheck: number,
    fieldName: string
) => {
    if (levelParents && levelParents.length > 0) {
        let jql = '';

        levelParents.forEach((parent: ParentOptionData) => {
            jql += ` AND "${fieldName}.level${parent.depth + 1}" = "${parent.value}"`;
        });

        return jql + ` AND "${fieldName}.level${levelToCheck}" = "${optionValue}"`;
    }

    return `AND "${fieldName}.level${levelToCheck}" = "${optionValue}"`;
};
